import type { Customer } from "@store/types";
import { useStore } from "../../store";
import { useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@lib/enums/QueryKeys";
import { useApi } from "@lib/helpers/useApi";
import type {
    MeCustomerRequest,
    MeCustomerResponseResponseModel,
} from "@interfaces/storefront-api";
import { useEffect } from "react";
import { useProfile } from "@hooks/useProfile";

export const useGetMyProfile = () => {
    const setMyProfile = useStore((state) => state.setMyProfile);

    const { data, isLoading, error, refetch, isFetching } = useProfile({
        queryConfig: {
            retry: false,
        },
    });

    useEffect(() => {
        setMyProfile((data ?? {}) as Customer);
    }, [data]);

    return {
        data,
        isLoading,
        error,
        refetch,
        isFetching,
    };
};

export const useUpdateProfile = () => {
    const queryClient = useQueryClient();

    const mutation = useApi.useMutate<MeCustomerRequest, MeCustomerResponseResponseModel>(
        `/api/user/update-user`,
        {
            method: "PUT",
            onSuccess: () => {
                // Invalidate and refetch profile, so we have the new version updated
                queryClient.invalidateQueries({ queryKey: [QueryKeys.getProfile] });
            },
        }
    );
    return { updateMyProfileMutation: mutation };
};
